import styles from "./style.module.css";

const AddBusinessesTextArea = ({ className, ...props }) => {
  return (
    <textarea className={[styles.input, className].join(" ")} {...props} />
  );
};

export default AddBusinessesTextArea;
